import { mapGetters } from 'vuex';

export default {
  name: 'HeaderLang',
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(['languages', 'currentLanguage'])
  },
  methods: {
    changeLanguage(code) {
      this.$setLanguage(code).then(() => {
        window.location.reload();
      });
    }
  }
};
